import { render, staticRenderFns } from "./MiniCalendar.vue?vue&type=template&id=90135652&scoped=true"
import script from "./MiniCalendar.vue?vue&type=script&lang=js"
export * from "./MiniCalendar.vue?vue&type=script&lang=js"
import style0 from "./MiniCalendar.vue?vue&type=style&index=0&id=90135652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90135652",
  null
  
)

export default component.exports